import { useState, useEffect } from "react";
import { subscribeToPaymentMethods, subscribeToInternalPaymentMethods } from "../services/customerService";

// Customer Payment Methods (used on Estimates and CRM Customers)
export function usePaymentMethods() {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    const unsubscribe = subscribeToPaymentMethods((data, err) => {
      if (err) {
        setError("Failed to load payment methods.");
        setLoading(false);
      } else {
        setPaymentMethods(data || []);
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  return { paymentMethods, loading, error };
}

// Internal Payment Methods (used in Purchase)
export function useInternalPaymentMethods() {
  const [internalPaymentMethods, setInternalPaymentMethods] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    const unsubscribe = subscribeToInternalPaymentMethods((data, err) => {
      if (err) {
        setError("Failed to load internal payment methods.");
        setLoading(false);
      } else {
        setInternalPaymentMethods(data || []);
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  return { internalPaymentMethods, loading, error };
}
